import React, { useEffect, useState } from "react";
import { Layout, Button, Space, Dropdown, MenuProps, Modal } from "antd";
import "./Header.css";
import styles from "./Header.module.scss";
import close from "@/assets/images/close.svg";

import { NavLink, useNavigate } from "react-router-dom";
import ConnectButton from "./ConnectButton";
import { useAccount } from "wagmi";
import { useDataStore } from "@/store/dataStore";
import { CacheAddress } from "@/constants/const";
import transfer from "@/assets/images/transfer.svg";

const { Header: AntHeader } = Layout;

const items: MenuProps["items"] = [
  {
    key: "1",
    label: (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://provernet-docs.brevis.network/"
      >
        Overview
      </a>
    ),
  },
  {
    key: "2",
    label: (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://provernet-docs.brevis.network/user-tutorial/staking-in-provernet"
      >
        User Staking Tutorial 
      </a>
    ),
  },
  {
    key: "3",
    label: (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://provernet-docs.brevis.network/operation-manual/operate-a-prover-node"
      >
        Prover Operation Manual
      </a>
    ),
  },
];

const Header: React.FC = () => {
  const { isConnected } = useAccount();
  const navigate = useNavigate();

  const isMobile = useDataStore((state) => state.isMobile);
  const [docsMenu, setDocsMenu] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CacheAddress.cacheAddress)) {
      navigate("/");
    }
  }, []);

  const DocsModal = () => {
    return (
      <Modal
        open={docsMenu}
        title="Docs"
        onOk={() => setDocsMenu(false)}
        onCancel={() => setDocsMenu(false)}
        closeIcon={<img src={close} alt="logo" width={24} height={24} />}
        destroyOnHidden
        className={styles.docsModal}
        footer={null}
        width={410}
      >
        <div
          className={styles.mobileDocsItem}
          onClick={() =>
            window.open("https://provernet-docs.brevis.network/", "_blank")
          }
        >
          Overview
        </div>
        <div
          className={styles.mobileDocsItem}
          onClick={() =>
            window.open(
              "https://provernet-docs.brevis.network/user-tutorial/staking-in-provernet",
              "_blank"
            )
          }
        >
          User Staking Tutorial 
        </div>
        <div
          className={styles.mobileDocsItem}
          onClick={() =>
            window.open(
              "https://provernet-docs.brevis.network/operation-manual/operate-a-prover-node",
              "_blank"
            )
          }
        >
          Prover Operation Manual
        </div>
      </Modal>
    );
  };

  return (
    <>
      <AntHeader className="app-header">
        <div className="logo">
          <img src="/logo.svg" alt="Brevis" onClick={() => navigate("/")} />
        </div>
        <div className="nav-links">
          <Space>
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                isActive ? "active-class" : "normal-class"
              }
            >
              Provers
            </NavLink>
            {isConnected && (
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  isActive ? "active-class" : "normal-class"
                }
              >
                Dashboard
              </NavLink>
            )}
          </Space>
        </div>
        <div className="header-actions">
          {!isMobile ? (
            <Button
              type="primary"
              style={{ marginRight: 16 }}
              className="contact-btn"
              onClick={() =>
                window.open(
                  "https://cbridge.celer.network/1/8453/BREV",
                  "_blank"
                )
              }
            >
              <img width={20} src={transfer} alt="docs" />
              <div className="btn-text">Bridge</div>
            </Button>
          ) : (
            <Button
              type="primary"
              style={{ marginRight: 8 }}
              className="contact-btn"
              onClick={() =>
                window.open(
                  "https://cbridge.celer.network/1/8453/BREV",
                  "_blank"
                )
              }
            >
              <img width={20} src={transfer} alt="docs" />
            </Button>
          )}
          {!isMobile ? (
            <Dropdown
              menu={{ items }}
              placement="bottomLeft"
              overlayClassName={styles.dropdownMenu}
              onOpenChange={(open) => {
                setDocsMenu(open);
              }}
            >
              <Button type="primary" className="contact-btn">
                {!isMobile && <img src="/docs.svg" alt="docs" />}
                Docs
              </Button>
            </Dropdown>
          ) : (
            <Button
              type="primary"
              className="contact-btn"
              onClick={() => setDocsMenu(true)}
            >
              <img src="/docs.svg" alt="docs" />
            </Button>
          )}
          <ConnectButton />
        </div>
      </AntHeader>
      {isMobile && isConnected && (
        <div className="mobile-nav-links">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              isActive ? "active-class" : "normal-class"
            }
          >
            Provers
          </NavLink>
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              isActive ? "active-class" : "normal-class"
            }
          >
            Dashboard
          </NavLink>
        </div>
      )}
      {docsMenu && isMobile && <DocsModal />}
    </>
  );
};

export default Header;
